import type { BariPostNurseSpecialistFollowUpDataBase } from '@common/validation/customControls/bariPost/bariPostNurseSpecialistFollowUp/bariPostNurseSpecialistFollowUpDataBase';

export const initialData: BariPostNurseSpecialistFollowUpDataBase = {
    alcohol: null,
    alcohol_aantal_eenheden_per_week: null,
    alcohol_toelichting: null,
    assets: [],
    beleid: null,
    beloop_aanvullende_anamnese: null,
    datum_verwijzing: null,
    diabetes_mellitus: null,
    diabetes_mellitus_medicamenteuze_veranderingen_toelichting: null,
    dumpingklachten: null,
    dumpingklachten_options: {
        dumpingklachten_late_dumping: null,
        dumpingklachten_vroege_dumping: null,
    },
    dumpingklachten_toelichting: null,
    dyslipidemie: null,
    dyslipidemie_medicamenteuze_veranderingen_toelichting: null,
    expert: null,
    expert_hulpvraag: null,
    extern_doorverwijzen: null,
    gastroesophageal_reflux_disease: null,
    gastroesophageal_reflux_disease_medicamenteuze_veranderingen_toelichting: null,
    gewrichtsklachten: null,
    gewrichtsklachten_therapeutische_veranderingen_toelichting: null,
    hba1c: null,
    huidige_medicatie: null,
    hypertensie: null,
    hypertensie_medicamenteuze_veranderingen_toelichting: null,
    interne_expert_inschakelen: false,
    medicatie: null,
    multivitaminen: null,
    multivitaminen_toelichting: null,
    naam_externe_behandelaar: null,
    ontlasting: null,
    ontlasting_frequentie_per_dag: null,
    osas: null,
    osas_therapeutische_veranderingen_toelichting: null,
    reden_doorverwijzing: null,
    reflux_klachten: null,
    reflux_klachten_toelichting: null,
    type_behandelaar: null,
    type_behandelaar_overig: null,
};
